import { Button, Grid2, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Typography,  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Box,
  Chip } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import TokenError from "../tokenError";
import { makeGetRequestToUrl } from "../commonFunc";
import config from "../../config/config";
import dayjs from "dayjs";
import { Label } from "flowbite-react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import InboxIcon from '@mui/icons-material/Inbox';

var constant = require('../../constant.js');

const RequestedRides = () => {
    const serverUrl = config.serverUrl;
    const navigate = useNavigate();

    const cities = JSON.parse(localStorage.getItem('cities'));
    const [rows, setRows] = useState([]);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('request_id');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [startDateFilter, setStartDateFilter] = useState(dayjs());
    const [endDateFilter, setEndDateFilter] = useState(dayjs());
    const date_format_dd_mm_yy = localStorage.getItem('date_format_dd_mm_yy');
    const utcOffset = parseInt(localStorage.getItem('utc_offset') || '330', 10);
    const timeZoneFormat = localStorage.getItem('time_zone_format') || '12';
    const [statusFilter, setStatusFilter] = useState(0);
    const [userIdFilter, setUserIdFilter] = useState('');
    const [clientIdFilter, setClientIdFilter] = useState('');
    const [userNameFilter, setUserNameFilter] = useState('');
    const [openDetailsModal, setOpenDetailsModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const ride_event_logs_enabled = localStorage.getItem('ride_event_logs_enabled');
    const [merchantFilter, setMerchantFilter] = useState('');
    const merchantIdFromLocal = localStorage.getItem('merchantId') || 0;
    const hasMerchant = merchantIdFromLocal && merchantIdFromLocal !== '0' && merchantIdFromLocal !== 'undefined' && merchantIdFromLocal !== 'null';
    const hasMerchantData = rows.some(r => r?.merchant_id);

    const [steps,setSteps] = useState([]);
    const clientId = localStorage.getItem('clientId');
    const formatTime = (eventTime) => {
    if (!eventTime) return "";

    const date = new Date(eventTime);

    // Convert to pure UTC timestamp (remove browser auto conversion)
    const utcTime = date.getTime() + (date.getTimezoneOffset() * 60000);

    // Now apply your custom utcOffset
    const adjustedDate = new Date(utcTime + utcOffset * 60000);

    return adjustedDate.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: timeZoneFormat === "12"
    });
    };
    const handleDetailsopen = (row) => {
        setSelectedRow(row);
        setSteps([]);
        setOpenDetailsModal(true);
        fetchRideLogData(row.request_id);
    };

    const handleCloseDetailsModal = () => {
        setOpenDetailsModal(false);
        setSelectedRow(null);
    };

  const getEventTitle = (code) => {
    const map = {
      CUSTOMER_REQUEST_RIDE: "Ride Requested",
      NO_DRIVER_AVAILABLE: "No Driver Available",
      DRIVER_ACCEPTED: "Driver Accepted",
      DRIVER_ARRIVED: "Driver Arrived",
      TRIP_STARTED: "Trip Started",
      TRIP_ENDED: "Trip Ended",
      CUSTOMER_APP_CANCELLED: "Customer App",
      DRIVER_APP_CANCELLED: "Driver App",
    };

    return map[code] || code.replaceAll("_", " ");
  };

  const getDescription = (log) => {
    switch (log.actor_type) {
      case "CUSTOMER":
        return `Customer (ID: ${log.actor_id} | Name: ${log.user_name}) initiated the ride request`;
      case "DRIVER":
        return `Driver (ID: ${log.actor_id} | Name: ${log.driver_name}) performed this action`;
      case "SYSTEM":
        return "System generated event";
      default:
        return "";
    }
  };

  useEffect(() => {
    setPage(0);
}, [statusFilter, userIdFilter, userNameFilter, clientIdFilter, merchantFilter]);

  const sortedLogs = [...(steps || [])].sort(
    (a, b) => new Date(a.event_time) - new Date(b.event_time)
  );

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const fetchRequestedRidesData = async () => {
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const url = `${serverUrl}/customer/fetch_requested`;
            const obj={
                token: token, timestamp: timestamp, city_id: cityFilter,
                start_date: startDateFilter.format('YYYY-MM-DD'),
                end_date: endDateFilter.format('YYYY-MM-DD')
            }

            const response =  await makeGetRequestToUrl(url, obj);
            if(response.flag == 200){
                setRows(response.data.trip_request_details);
            }

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchRideLogData = async (request_id) => {
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const url = serverUrl +`/customer/fetch_ride_event_logs`;
            const obj={
                token: token,
                request_id: request_id
            }

            const response =  await makeGetRequestToUrl(url, obj);
            if(response.flag == 200){
                console.log('response = ', response);
                setSteps(response?.data);
            }

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    // Get the filtered data for rendering with memoization
    const filteredRows = useMemo(() => {
        let filteredData = [...rows];
        
        // Apply status filter
        if (statusFilter !== 0) {
            filteredData = filteredData.filter(row => row.status == statusFilter);
        }
        
        // Apply user ID filter
        if (userIdFilter !== '') {
            filteredData = filteredData.filter(row => 
                row.user_id && row.user_id.toString().includes(userIdFilter.toString())
            );
        }
        
        // Apply client ID filter
        if (clientIdFilter !== '') {
            filteredData = filteredData.filter(row => 
                row.user_code && row.user_code.toString().toLowerCase().includes(clientIdFilter.toLowerCase())
            );
        }
        
        // Apply user name filter
        if (userNameFilter !== '') {
            filteredData = filteredData.filter(row => 
                row.user_name && row.user_name.toLowerCase().includes(userNameFilter.toLowerCase())
            );
        }
        
        // Apply merchant filter
        if (merchantFilter !== '') {
            filteredData = filteredData.filter(row =>
                merchantFilter === 'none'
                    ? !row.merchant_id
                    : String(row.merchant_id) === String(merchantFilter)
            );
        }

        return filteredData;
    }, [rows, statusFilter, userIdFilter, userNameFilter, clientIdFilter, merchantFilter]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const rowArray = Array.isArray(filteredRows) ? filteredRows : [];
    const totalEntries = rowArray.length;
    const totalPages = Math.ceil(totalEntries / rowsPerPage);
    const currentPage = Math.min(page, totalPages - 1);

    useEffect(() => {
        fetchRequestedRidesData();
    }, [cityFilter, startDateFilter, endDateFilter])

    const exportCSV = () => {
        // Define which columns to include in the CSV
        const headers = [
            'Request ID',
            'User ID',
            'User name',
            'User phone number',
            'Driver ID',
            'Driver name',
            'Driver phone number',
            'Pickup Latitude',
            'Pickup Longitude',
            'Pickup Address',
            'Drop Latitude',
            'Drop Longitude',
            'Drop Address',
            'Status',
            'Ride Distance',
            'Estimated Fare',
            'Promo Name',
            'Discount Amount',
            'Trip Time',
            'Driver Arrival Time',
            'Scheduled ID',
            'Cancellation Reason',
            'Refund Amount',
            'Actual Refund Amount',
            'Created At',
            'Updated At'
        ];

        // Map the data rows to match the headers
        const csvData = rows.map(row => {
            
            return [
                row.request_id,
                row.user_id,
                row.user_name,
                row.phone_number,
                row.driver_id,
                row.driver_name,
                row.driver_phone_number,
                row.pickup_latitude,
                row.pickup_longitude,
                row.pickup_address,
                row.drop_latitude,
                row.drop_longitude,
                row.drop_address,
                row.status ==1 ? 'Alive' : row.status == 2 ? 'Accepted' : row.status ==3 ? 'Timeout' 
                    : row.status==4 ? 'Started' : row.status ==5 ? 'Ended' : row.status == 6 ? 'Cancelled by customer' 
                    : row.status ==7 ? 'Cancelled by driver' : row.status == 8 ? 'Cancelled by admin' 
                    : row.status==9 ? 'Customer No Show' : row.status==10 ? 'Cancelled by system' : row.status==11 ? 'Driver No Show' : 'Unknown',
                row.ride_distance,
                row.estimated_fare,
                row.promo_name,
                row.discount_amount,
                row.trip_time ? 
                    (() => {
                        const pickupDate = new Date(row.trip_time);
                        // Add the offset minutes to the date
                        pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                        return pickupDate.toLocaleString('en-GB', {
                        day: '2-digit', 
                        month: '2-digit', 
                        year: 'numeric', 
                        hour: '2-digit', 
                        minute: '2-digit', 
                        hour12: timeZoneFormat == '12' ? true : false,
                        timeZone: 'UTC'
                        }).replace(',', ' |');
                    })() 
                    : '',
                row.driver_arrival_time ? 
                    (() => {
                        const pickupDate = new Date(row.driver_arrival_time);
                        // Add the offset minutes to the date
                        pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                        return pickupDate.toLocaleString('en-GB', {
                        day: '2-digit', 
                        month: '2-digit', 
                        year: 'numeric', 
                        hour: '2-digit', 
                        minute: '2-digit', 
                        hour12: timeZoneFormat == '12' ? true : false,
                        timeZone: 'UTC'
                        }).replace(',', ' |');
                    })() 
                    : '',
                row.scheduled_id,
                row.cancellation_reason ? row.cancellation_reason : '',
                row.refund_amount ? row.refund_amount : '-',
                row.actual_refund_amount ? row.actual_refund_amount : '-',
                row.created_at ? 
                    (() => {
                        const pickupDate = new Date(row.created_at);
                        // Add the offset minutes to the date
                        pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                        return pickupDate.toLocaleString('en-GB', {
                        day: '2-digit', 
                        month: '2-digit', 
                        year: 'numeric', 
                        hour: '2-digit', 
                        minute: '2-digit', 
                        hour12: timeZoneFormat == '12' ? true : false,
                        timeZone: 'UTC'
                        }).replace(',', ' |');
                    })() 
                    : '',
                row.updated_at ? 
                    (() => {
                        const pickupDate = new Date(row.updated_at);
                        // Add the offset minutes to the date
                        pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                        return pickupDate.toLocaleString('en-GB', {
                        day: '2-digit', 
                        month: '2-digit', 
                        year: 'numeric', 
                        hour: '2-digit', 
                        minute: '2-digit', 
                        hour12: timeZoneFormat == '12' ? true : false,
                        timeZone: 'UTC'
                        }).replace(',', ' |');
                    })() 
                    : '',
            ];
        });

        // Create CSV content
        let csvContent = headers.join(',') + '\n';
        csvData.forEach(rowArray => {
            // Properly escape fields that might contain commas
            const formattedRow = rowArray.map(field => {
                // Convert to string and check if it needs quotes
                const stringField = String(field || '');
                if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
                    // Escape quotes and wrap in quotes
                    return `"${stringField.replace(/"/g, '""')}"`;  
                }
                return stringField;
            });
            csvContent += formattedRow.join(',') + '\n';
        });

        // Create a blob and download link
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        
        link.setAttribute('href', url);
        link.setAttribute('download', `requested_rides.csv`);
        link.style.visibility = 'hidden';
        
        // Append to document, trigger download, and clean up
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleUserIdChange = (e) => {
        const value = e.target.value;
        setUserIdFilter(value);
    };

    const handleClientIdChange = (e) => {
        const value = e.target.value;
        setClientIdFilter(value);
    }

    const handleUserNameChange = (e) => {
        const value = e.target.value;
        setUserNameFilter(value);
    };

    return (
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Requested Rides
            </Typography>

            <Grid2 container spacing={1.5} xs={12} md={8} alignItems="flex-end">
                <Select
                    value={cityFilter}
                    onChange={(e) => setCityFilter(e.target.value)}
                    displayEmpty
                    style={{
                        width: '180px',
                        height: '44px',
                        borderRadius: '8px',
                        backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
                    }}
                >
                    <MenuItem value="">Select City</MenuItem>
                    {cities.map((city) => (
                        <MenuItem key={city.city_id} value={city.city_id}>
                            {city.city_name}
                        </MenuItem>
                    ))}
                </Select>

                <Grid2 item>
                    <Label>Start Date:</Label><br/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                                } 
                            }}
                            sx={{
                                width: '160px',
                                '& .MuiInputBase-root': {
                                    minHeight: '44px',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                    marginTop:'4px',
                                    minWidth:'160px'
                                }
                            }}
                            value={startDateFilter}
                            format={date_format_dd_mm_yy ? "DD/MM/YYYY" : "YYYY/MM/DD"}
                            onChange={(newValue) => {
                                if (endDateFilter && newValue && newValue.isAfter(endDateFilter)) {
                                    setEndDateFilter(null);
                                }
                                setStartDateFilter(newValue);
                            }}
                            maxDate={endDateFilter || undefined}
                        />
                    </LocalizationProvider>
                </Grid2>

                <Grid2 item>
                    <Label>End Date:</Label><br/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            format={date_format_dd_mm_yy ? "DD/MM/YYYY" : "YYYY/MM/DD"}
                            slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                                } 
                            }}
                            sx={{
                                width: '160px',
                                '& .MuiInputBase-root': {
                                    minHeight: '44px',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                    marginTop:'4px',
                                    minWidth:'160px'
                                }
                            }}
                            value={endDateFilter}
                            onChange={(newValue) => {
                                setEndDateFilter(newValue)
                            }}
                            minDate={startDateFilter || undefined}
                        />
                    </LocalizationProvider>
                </Grid2>

                <Grid2 item>
                    <Label>Status:</Label><br/>
                    <Select value={statusFilter} onChange={(e) => {setStatusFilter(e.target.value)}}
                        style={{
                            width: '180px', marginTop:'4px',
                            height: '44px',
                            borderRadius: '8px',
                            backgroundColor:'#FFFFFF',
                        }}
                    >
                        <MenuItem value={0}>All</MenuItem>
                        <MenuItem value={1}>Alive</MenuItem>
                        <MenuItem value={2}>Accepted</MenuItem>
                        <MenuItem value={3}>Timeout</MenuItem>
                        <MenuItem value={4}>Started</MenuItem>
                        <MenuItem value={5}>Ended</MenuItem>
                        <MenuItem value={6}>Cancelled by customer</MenuItem>
                        <MenuItem value={7}>Cancelled by driver</MenuItem>
                        <MenuItem value={8}>Cancelled by admin</MenuItem>
                        <MenuItem value={9}>Customer no show</MenuItem>
                        <MenuItem value={10}>Cancelled by system</MenuItem>
                        <MenuItem value={11}>Driver no show</MenuItem>
                    </Select>
                </Grid2>

                {!hasMerchant && hasMerchantData && (
                    <Grid2 item>
                        <Label>Merchant:</Label><br/>
                        <Select
                            value={merchantFilter}
                            onChange={(e) => setMerchantFilter(e.target.value)}
                            displayEmpty
                            style={{ width: '190px', marginTop:'4px', height: '44px', borderRadius: '8px', backgroundColor:'#FFFFFF' }}
                        >
                            <MenuItem value="">All Merchants</MenuItem>
                            {Array.from(
                                new Map(
                                    rows
                                        .filter(r => r && r.merchant_id)
                                        .map(r => [String(r.merchant_id), r.merchant_name || `Merchant ${r.merchant_id}`])
                                ).entries()
                            ).map(([id, name]) => (
                                <MenuItem key={id} value={id}>
                                    {name} <span style={{color:'#AC8312', marginLeft:'4px'}}>(ID: {id})</span>
                                </MenuItem>
                            ))}
                            <MenuItem value="none">No Merchant (regular rides)</MenuItem>
                        </Select>
                    </Grid2>
                )}

                <Grid2 item>
                    <Label>User Id:</Label><br/>
                    <input type="number" placeholder="User Id" className='filterBtn' value={userIdFilter} onChange={handleUserIdChange} min="0"
                    onKeyDown={(e) => {
                        if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                            e.preventDefault();
                        }
                    }}
                    style={{
                        width: '150px', marginTop:'4px',
                        height: '44px',
                        borderRadius: '8px',
                        backgroundColor: '#FFFFFF',
                    }}
                        />
                </Grid2>

                {clientId == 188 && <Grid2 item>
                    <Label>Client Id:</Label><br/>
                    <input placeholder="Client Id" className='filterBtn' value={clientIdFilter} onChange={handleClientIdChange}
                    style={{
                        width: '150px', marginTop:'4px',
                        height: '44px',
                        borderRadius: '8px',
                        backgroundColor: '#FFFFFF',
                    }}
                        />
                </Grid2>}

                <Grid2 item>
                    <Label>User Name:</Label><br/>
                    <input type="text" placeholder="User Name" className='filterBtn' value={userNameFilter} onChange={handleUserNameChange}
                        style={{
                            width: '180px', marginTop:'4px',
                            height: '44px',
                            borderRadius: '8px',
                            backgroundColor: '#FFFFFF',
                        }}
                    />
                </Grid2>

                <Grid2 item sx={{marginLeft:'1%', marginLeft:'auto'}}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={exportCSV}
                        sx={{
                            height: '44px',
                            width: '160px',
                            textTransform: 'none',
                            borderRadius: '8px',
                            backgroundColor: '#36C68F',
                            '&:hover': {
                                backgroundColor: '#36C68F',
                            },
                        }}
                    >
                        Export CSV
                    </Button>
                </Grid2>
            </Grid2>

            <TableContainer className="table-container" sx={{ maxHeight:'68vh' }}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell component="th" align="center" className="table-header" style={{ width: '12%' }}>
                                <TableSortLabel
                                    active={orderBy === 'request_id'}
                                    direction={orderBy === 'request_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('request_id')}
                                >
                                    Request ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'80px' }}>User</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'80px' }}>Driver</TableCell>
                            {clientId == 188 && <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'80px' }}>Client Id</TableCell>}
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'80px' }}>Vehicle Name</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'80px' }}>Vehicle Type</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'80px' }}>Pickup Latitude/Longitude</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'80px' }}>Pickup Address</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'80px' }}>Drop Latitude/Longitude</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%', minWidth:'80px' }}>Drop Address</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%', minWidth:'80px' }}>Status</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%', minWidth:'80px' }}>Ride Distance</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%', minWidth:'80px' }}>Estimated Fare</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%', minWidth:'80px' }}>Promo Name</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%', minWidth:'80px' }}>Discount Amount</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%', minWidth:'80px' }}>Trip Time</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%', minWidth:'80px' }}>Driver Arrival Time</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%', minWidth:'80px' }}>Scheduled ID</TableCell>
                            {hasMerchantData && <TableCell align="center" className="table-header" style={{ width: '10%', minWidth:'80px' }}>Merchant</TableCell>}
                            <TableCell align="center" className="table-header" style={{ width: '10%', minWidth:'80px' }}>Cancellation Reason</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%', minWidth:'80px' }}>Refund Amount</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%', minWidth:'80px' }}>Actual Refund Amount</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'80px' }}>Created At</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'80px' }}>Updated At</TableCell>
                            {ride_event_logs_enabled == 1 && <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'80px' }}>Ride Logs</TableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredRows.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={20} align="center">
                                    <Typography>No data available</Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            filteredRows
                            .slice(currentPage * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row) => {
                                return(
                                    <TableRow key={row.request_id}>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.request_id}</Typography></TableCell>
                                    <TableCell align="center" sx={{minWidth:'150px'}}>
                                        <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                            <Typography sx={{ 
                                                fontSize: '14px', textAlign: 'left', backgroundColor: '#FFFFFF', padding: '0px 2px', 
                                                textDecoration: '#AC8312', borderRadius: "4px" 
                                            }}>
                                                {row.user_id && (
                                                    <>
                                                    <span style={{ color: '#9FA3A7' }}>User Id: </span>
                                                    <span style={{ color: '#AC8312' }}>{row.user_id}</span>
                                                    </>
                                                )}
                                            </Typography>
                                            {row.user_name && (
                                                <Typography sx={{ color: '#4E545D', fontSize: '16px' }}>{row.user_name}</Typography>
                                            )}
                                            {row.phone_number && (
                                                <Typography sx={{ color: "#9FA3A7", fontSize: "12px" }}>{row.phone_number}</Typography>
                                            )}
                                        </Grid2>
                                    </TableCell>
                                    <TableCell align="center" sx={{minWidth:'150px'}}>
                                        <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                            {!row.driver_id && 
                                                <Typography sx={{textAlign:'center'}}>--</Typography>
                                            }
                                            <Typography sx={{ 
                                                fontSize: '14px', textAlign: 'left', backgroundColor: '#FFFFFF', padding: '0px 2px', 
                                                textDecoration: '#AC8312', borderRadius: "4px" 
                                            }}>
                                                {row.driver_id && (
                                                    <>
                                                    <span style={{ color: '#9FA3A7' }}>Driver Id: </span>
                                                    <span style={{ color: '#AC8312' }}>{row.driver_id}</span>
                                                    </>
                                                )}
                                            </Typography>
                                            {row.driver_name && (
                                                <Typography sx={{ color: '#4E545D', fontSize: '16px' }}>{row.driver_name}</Typography>
                                            )}
                                            {row.driver_phone_number && (
                                                <Typography sx={{ color: "#9FA3A7", fontSize: "12px" }}>{row.driver_phone_number}</Typography>
                                            )}
                                        </Grid2>
                                    </TableCell>
                                    {clientId == 188 && <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.user_code}</Typography></TableCell>} 
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.vehicle_name}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{constant.VehicleTypes[row.vehicle_type]}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.pickup_latitude}, {row.pickup_longitude}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '160px' }}>{row.pickup_address}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.drop_latitude}, {row.drop_longitude}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '160px' }}>{row.drop_address}</Typography></TableCell>
                                    <TableCell align="center">
                                        <Typography sx={{ width: 'auto', minWidth: '100px', 
                                            color: (row.status==6 || row.status==7 || row.status==8 || row.status==9 || row.status==10 || row.status==11) ? '#C71F1F' 
                                            : row.status==5 ? '#0DBA78' : (row.status==1 || row.status==2) ? '#0065ff'
                                            : (row.status==3 || row.status==4) ? '#FFA500'
                                            : 'black' }}>
                                        {row.status ==1 ? 'Alive' : row.status == 2 ? 'Accepted' : row.status ==3 ? 'Timeout' 
                                        : row.status==4 ? 'Started' : row.status ==5 ? 'Ended' : row.status == 6 ? 'Cancelled by customer' 
                                        : row.status ==7 ? 'Cancelled by driver' : row.status == 8 ? 'Cancelled by admin' 
                                        : row.status==9 ? 'Customer No Show' : row.status==10 ? 'Cancelled by system' : row.status==11 ? 'Driver No Show' : 'Unknown'}
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.ride_distance}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.estimated_fare}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.promo_name}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.discount_amount}</Typography></TableCell>
                                    <TableCell align="center">
                                        <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                            {row?.trip_time ? 
                                                (() => {
                                                const pickupDate = new Date(row?.trip_time);
                                                // Add the offset minutes to the date
                                                pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                                                return pickupDate.toLocaleString('en-GB', {
                                                    day: '2-digit', 
                                                    month: '2-digit', 
                                                    year: 'numeric', 
                                                    hour: '2-digit', 
                                                    minute: '2-digit', 
                                                    hour12: timeZoneFormat == '12' ? true : false,
                                                    timeZone: 'UTC'
                                                }).replace(',', ' |');
                                                })() 
                                                : '--'
                                            }
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                            {row?.trip_time ? 
                                                (() => {
                                                const pickupDate = new Date(row?.driver_arrival_time);
                                                // Add the offset minutes to the date
                                                pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                                                return pickupDate.toLocaleString('en-GB', {
                                                    day: '2-digit', 
                                                    month: '2-digit', 
                                                    year: 'numeric', 
                                                    hour: '2-digit', 
                                                    minute: '2-digit', 
                                                    hour12: timeZoneFormat == '12' ? true : false,
                                                    timeZone: 'UTC'
                                                }).replace(',', ' |');
                                                })() 
                                                : '--'
                                            }
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.scheduled_id}</Typography></TableCell>
                                    {hasMerchantData && (
                                        <TableCell align="center">
                                            <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                                {row.merchant_id ? `${row.merchant_name || '--'} (ID: ${row.merchant_id})` : '--'}
                                            </Typography>
                                        </TableCell>
                                    )}
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.cancellation_reason ? row.cancellation_reason : '--'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.refund_amount ? row.refund_amount : '--'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.actual_refund_amount ? row.actual_refund_amount : '--'}</Typography></TableCell>
                                    <TableCell align="center">
                                        <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                           {row?.created_at ? 
                                                (() => {
                                                const pickupDate = new Date(row?.created_at);
                                                // Add the offset minutes to the date
                                                pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                                                return pickupDate.toLocaleString('en-GB', {
                                                    day: '2-digit', 
                                                    month: '2-digit', 
                                                    year: 'numeric', 
                                                    hour: '2-digit', 
                                                    minute: '2-digit', 
                                                    hour12: timeZoneFormat == '12' ? true : false,
                                                    timeZone: 'UTC'
                                                }).replace(',', ' |');
                                                })() 
                                                : '--'
                                            }
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                            {row?.updated_at ? 
                                                (() => {
                                                const pickupDate = new Date(row?.updated_at);
                                                // Add the offset minutes to the date
                                                pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                                                return pickupDate.toLocaleString('en-GB', {
                                                    day: '2-digit', 
                                                    month: '2-digit', 
                                                    year: 'numeric', 
                                                    hour: '2-digit', 
                                                    minute: '2-digit', 
                                                    hour12: timeZoneFormat == '12' ? true : false,
                                                    timeZone: 'UTC'
                                                }).replace(',', ' |');
                                                })() 
                                                : '--'
                                            }
                                        </Typography>
                                    </TableCell>
                                    {ride_event_logs_enabled === '1' && <TableCell align="center">
                                        <Button
                                            variant="contained"
                                            onClick={() => handleDetailsopen(row)}
                                            sx={{
                                                backgroundColor: "white",
                                                color: "#d9881eff",
                                                border: "1px solid #d9881eff",
                                                textTransform: "none",
                                                borderRadius: "8px",
                                                width: "auto", // Or set a specific width
                                                minWidth: "120px",
                                                marginBottom: "10px",
                                                "&:hover": {
                                                backgroundColor: "#fa8517ff",
                                                color: "white",
                                                },
                                                "&:active": {
                                                backgroundColor: "#f56a0dff",
                                                color: "white",
                                                },
                                            }}
                                            >
                                             View Details
                                            </Button>
                                    </TableCell>}
                                </TableRow>
                            )
                            })
                        )}
                    </TableBody>
                </Table>
                
                {rows && (
                    <div className="custom-pagination">
                        <div className="pagination-info">
                            {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            filteredRows.length
                            )} of ${filteredRows.length} entries`}
                        </div>
                        <div className="pagination-controls">
                            <button
                                onClick={() => handleChangePage(null, page - 1)}
                                disabled={page === 0}
                                className="pagination-arrow"
                            >
                                <img src={prevIcon} alt="Previous" />
                            </button>
                            <div className="pagination-numbers">
                                {page > 1 && (
                                    <>
                                    <button
                                        onClick={() => handleChangePage(null, 0)}
                                        className="pagination-number"
                                    >
                                        1
                                    </button>
                                    <span className="pagination-dots">...</span>
                                    </>
                                )}
                                {[...Array(Math.ceil(filteredRows.length / rowsPerPage))]
                                    .map((_, index) => index)
                                    .filter((index) => index >= page - 1 && index <= page + 1) // Show only previous, current, and next page
                                    .map((index) => (
                                    <button
                                        key={index}
                                        onClick={() => handleChangePage(null, index)}
                                        className={`pagination-number ${
                                        page === index ? "active" : ""
                                        }`}
                                    >
                                        {index + 1}
                                    </button>
                                ))}

                                {page < Math.ceil(filteredRows.length / rowsPerPage) - 2 && (
                                    <>
                                    <span className="pagination-dots">...</span>
                                    <button
                                        onClick={() =>
                                            handleChangePage(
                                                null,
                                                Math.ceil(filteredRows.length / rowsPerPage) - 1
                                            )
                                        }
                                        className="pagination-number"
                                    >
                                        {Math.ceil(filteredRows.length / rowsPerPage)}
                                    </button>
                                    </>
                                )}
                            </div>
                            <button
                                onClick={() => handleChangePage(null, page + 1)}
                                disabled={
                                    page >= Math.ceil(filteredRows.length / rowsPerPage) - 1
                                }
                                className="pagination-arrow"
                            >
                                <img src={nextIcon} alt="Next" />
                            </button>
                        </div>
                    </div>
                )}
            </TableContainer>
            <Dialog
                    open={openDetailsModal}
                    onClose={() => setOpenDetailsModal(false)}
                    maxWidth="md"
                    fullWidth
                    PaperProps={{
                      sx: { borderRadius: "12px", padding: "10px" }
                    }}
                  >
                    <DialogTitle sx={{ fontWeight: "bold" }}>
                       Ride Status Logs
                    </DialogTitle>
            
                    <DialogContent dividers>
                        <Stepper orientation="vertical">
                        {steps.length > 0 ? steps.map((log, index) => (
                            <Step key={index} active completed>
                            <StepLabel
                                StepIconComponent={() => (
                                <CheckCircleIcon color="success" />
                                )}
                            >
                                <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                >
                                <Box>
                                    <Typography fontWeight="bold" >
                                        {getEventTitle(log.event_code)} - {(log.source_app).split("_")[0]} {log.source_app.split("_")[1]}
                                    </Typography>

                                    <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    >
                                    {getDescription(log)}
                                    </Typography>
                                </Box>

                                <Chip
                                    label={formatTime(log.event_time)}
                                    size="small"
                                    sx={{
                                    fontSize: "12px",
                                    backgroundColor: "#F3F4F6"
                                    }}
                                />
                                </Box>
                            </StepLabel>
                            </Step>
                        )) : 
                        <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            py: 6,
                            color: '#9FA3A7'
                        }}
                        >
                        <InboxIcon sx={{ fontSize: 60, mb: 2, color: '#D1D5DB' }} />

                        <Typography
                            variant="h6"
                            sx={{ fontWeight: 500, color: '#4E545D' }}
                        >
                            No Logs Found
                        </Typography>

                        <Typography
                            variant="body2"
                            sx={{ mt: 1, color: '#9FA3A7' }}
                        >
                            There are no activity logs available for this ride yet.
                        </Typography>
                        </Box>
                        }
                        </Stepper>
                    </DialogContent>
            
                    <DialogActions>
                      <Button
                        onClick={() => handleCloseDetailsModal()}
                        sx={{
                          borderRadius: "8px",
                          textTransform: "none"
                        }}
                      >
                        Close
                      </Button>
                    </DialogActions>
                  </Dialog>
        </div>
    );
};

export default RequestedRides;